import "./ServicesSection.css";

import { Box, Typography } from "@mui/material";

import {
  AutoAwesomeOutlined,
  CleaningServicesOutlined,
  LocalShippingOutlined,
  WorkspacePremiumOutlined
} from "@mui/icons-material";
import React from "react";
import footerWaveBg from "../../assets/images/start_bg.png";
import footerWaveBgMoblie from "../../assets/images/start_bg_mobile.png";

const services = [
  {
    icon: <WorkspacePremiumOutlined />,
    title: "One Stop Care",
    desc: "Everything Under One Roof",
  },
  {
    icon: <CleaningServicesOutlined />,
    title: "Clean Repair Restore",
    desc: "Expert Care For All Items",
  },
  {
    icon: <AutoAwesomeOutlined />,
    title: "Premium Services",
    desc: "Quality In Every Detail",
  },
  {
    icon: <LocalShippingOutlined />,
    title: "Pickup & Delivery",
    desc: "Convenient Doorstep Service",
  },
];

function ServicesSection() {
  // const services = [
  //   {
  //     icon: <CheckroomOutlined />,
  //     title: "One Stop Care",
  //     desc: "Everything Under One Roof",
  //   },
  //   {
  //     icon: <IronOutlined />,
  //     title: "Steam Ironing",
  //     desc: "Perfectly pressed",
  //   },
  //   {
  //     icon: <LocalLaundryServiceOutlined />,
  //     title: "Laundry Service",
  //     desc: "Fresh & Hygienic",
  //   },
  //   {
  //     icon: <AutoAwesomeOutlined />,
  //     title: "Wedding Care",
  //     desc: "Special care for your special day",
  //   },
  // ];

  return (
    <>
      <Box
        sx={{
          backgroundImage: {
            xs: `url(${footerWaveBgMoblie})`,
            md: `url(${footerWaveBg})`,
          },
          //   backgroundImage: `url(${footerWaveBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",

          minHeight: {
            xs: 220,
            md: 170,
          },

          px: {
            xs: 2,
            sm: 3,
            md: 6,
          },

          py: {
            xs: 4,
            md: 3,
          },

          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "space-between",

            rowGap: {
              xs: 3,
              md: 0,
            },
          }}
        >
          {services.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: {
                  xs: "50%",
                  md: "24%",
                },

                display: "flex",

                alignItems: "center",

                gap: {
                  xs: 1.5,
                  md: 2,
                },

                mb: {
                  xs: 1,
                  md: 0,
                },
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: 52,
                    md: 62,
                  },

                  height: {
                    xs: 52,
                    md: 62,
                  },

                  borderRadius: "50%",

                  background: "rgba(255,255,255,0.08)",

                  border: "1.5px solid rgba(255,255,255,0.55)",

                  backdropFilter: "blur(12px)",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  flexShrink: 0,

                  boxShadow: "0 8px 25px rgba(255,255,255,0.08)",
                }}
              >
                {React.cloneElement(item.icon, {
                  sx: {
                    color: "#fff",

                    fontSize: {
                      xs: 24,
                      md: 30,
                    },
                  },
                })}
              </Box>

              <Box>
                <Typography
                  sx={{
                    color: "#fff",

                    fontWeight: 700,

                    fontSize: {
                      xs: "16px",
                      md: "20px",
                    },

                    lineHeight: 1.2,

                    mb: 0.4,
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    color: "rgba(255,255,255,.88)",

                    fontSize: {
                      xs: "12px",
                      md: "15px",
                    },

                    lineHeight: 1.4,
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}

export default ServicesSection;
